import UDConfirmModal from './confirm-modal';
import UDModal from './modal';
import { ModalBody, ModalFooter, ModalHeader } from './modal-parts';

export * from './confirm-modal';
export * from './modal';
export * from './modal-parts';
export { MODAL_WIDTHS } from './styles';

// Compound component pattern
const Modal = Object.assign(UDModal, {
  Header: ModalHeader,
  Body: ModalBody,
  Footer: ModalFooter,
  Confirm: UDConfirmModal,
});

export default Modal;
